import type { CSSProperties, ReactNode } from 'react'

type SheetPortalContentProps = {
  isBodyPortal: boolean
  centeredHostStyle: CSSProperties
  children: ReactNode
}

export function SheetPortalContent({ isBodyPortal, centeredHostStyle, children }: SheetPortalContentProps) {
  if (isBodyPortal) {
    return <div style={centeredHostStyle}>{children}</div>
  }

  return children
}
